















































import { Component, Prop, Vue } from "vue-property-decorator";
// components
import FolderTree from "@/components/common/folders/FolderTree.vue";
// types
import { Folder, FolderEntites } from "@/services/folders/types";
import { FilesFilterDtoIn, MediaType, VscFile } from "@/services/files/types";
import { getFilteredFiles } from "@/services/files/fileService";
import { FILEENDPOINT } from "@/app.config";

@Component({
    components: {
        "folder-tree": FolderTree
    }
})
export default class SelectMediaFolderModal extends Vue {
    @Prop() id!: string;
    // folders
    folderId = "" as string;
    folderEntity = FolderEntites.Files;
    selectedFolderNode = {} as Folder;
    showFolderTree = true;
    vscFiles = [] as Array<VscFile>;
    mediaType = MediaType;

    open(folderId: string = "") {
        this.folderId = folderId;
        this.$bvModal.show(this.id);
    }

    close() {
        this.$bvModal.hide(this.id);
    }

    select() {
        this.$bvModal.hide(this.id);
        this.$emit("select", this.selectedFolderNode);
    }

    resetState() {
        this.selectedFolderNode = {} as Folder;
    }

    // lifecycle hooks
    public created(): void {
        this.fetchData();
    }

    get folderActive(): boolean {
        return !!this.selectedFolderNode.id;
    }

    typeCount(mediaType: MediaType): number {
        return this.vscFiles.filter(
            x => x.mediaType === mediaType
        ).length;
    }

    getFileSrc(file: VscFile): string {
        return file.thumbnailId
            ? `${FILEENDPOINT}${file.thumbnailId}` : "/test.jpg";
    }

    setSelectedFolder(folder: Folder) {
        this.selectedFolderNode = folder;
        this.fetchData();
    }

    fetchData() {
        getFilteredFiles({
            mediaTypes: [MediaType.Image, MediaType.Video] as MediaType[],
            folderId: this.selectedFolderNode ? this.selectedFolderNode.id : "",
            folderEntity: FolderEntites.Files
        } as FilesFilterDtoIn).then(response => {
            this.vscFiles = response.files;
        });
    }
}
